import { ReactElement } from 'react'
import { Text } from '../../Atoms'
import { Flex, Grid } from '../../Molecules'
import { SearchResultTextProps } from './props'

const SearchResultText = ({
    needle,
    text,
    t,
}: SearchResultTextProps): ReactElement => {
    const countWords = (searchTerm: string) => {
        return text.split(searchTerm).length - 1
    }

    const needleOccurrences = needle
        .split(' ')
        .map((word) => {
            return { word: word, count: countWords(word) }
        })
        .sort((r1, r2) => r2.count - r1.count)

    const charsCountBeforeNeedle = text.includes(needle)
        ? text.split(needle)[0].length
        : text.split(needleOccurrences[0].word)[0].length

    const charsCountWithNeedle = text.includes(needle)
        ? charsCountBeforeNeedle + needle.length
        : charsCountBeforeNeedle + needleOccurrences[0].word.length

    const charsCountAfterNeedle = text.slice(
        charsCountWithNeedle,
        charsCountWithNeedle + 50
    ).length

    const charsCountBeforeUnder20 = charsCountBeforeNeedle <= 20
    const charsCountAfterUnder20 = charsCountAfterNeedle <= 40

    const before = charsCountBeforeUnder20
        ? text.slice(0, charsCountBeforeNeedle)
        : '...' +
          text.slice(charsCountBeforeNeedle - 20, charsCountBeforeNeedle)

    const content = !text.includes(needle)
        ? ''
        : text.includes(needle)
        ? needle
        : needleOccurrences[1].count < 1
        ? needleOccurrences
              .filter((r) => r.count !== 0)
              .map((r) => r.word)
              .join(', ')
        : ''

    const after = text.slice(charsCountWithNeedle, charsCountWithNeedle + 40)

    const matches = !text.includes(needle) && (
        <Flex gap={4}>
            <Text
                css={{
                    color: '$neutral500',
                }}
                bold
            >
                {t.matches}
            </Text>
            <Text
                css={{
                    color: '$neutral500',
                }}
            >
                {needleOccurrences
                    .filter((r) => r.count !== 0)
                    .map((r) => r.word)
                    .join(', ')}
            </Text>
        </Flex>
    )

    return (
        <Grid>
            <Text
                css={{
                    color: '$neutral400',
                }}
            >
                {before}
                <Text bold primary>
                    {content}
                </Text>
                {after}
                {!charsCountAfterUnder20 && '...'}
            </Text>
            {text !== '' ? matches : ''}
        </Grid>
    )
}

export default SearchResultText
